import React from 'react';
import PropTypes from 'prop-types';

import styles from './SideMenu.m.sass';
import cartCounter from '../header/Header.m.sass';
import signIn from '../header/Header.m.sass';

import {Helmet} from 'react-helmet';
import {CSSTransitionGroup} from 'react-transition-group';
import {Link} from 'react-router';

import CloseIcon from '-!svg-react-loader?name=CloseIcon!../header/assets/close.svg';
import CartIcon from '-!svg-react-loader?name=CartIcon!../header/assets/cart.svg';
import userIcon from '../header/assets/user.svg';
import SearchBarContainer from '../searchBarContainer/SearchBarContainer';
import RoundSocials from '../roundSocials/RoundSocials';
import RoundButton from "../roundButton/RoundButton";
import ChannelDropdown from '../../containers/channelUtils/ChannelDropdown';
import Logo from '../logo/Logo';

export default class SideMenu extends React.PureComponent {
  static menu = [
    {name: 'Reviews', to: '/how-it-works'},
    {name: 'Guarantee', to: '/guarantee'},
    {name: 'Contact Us', to: '/contactus'}
  ];

  render() {
    const {isOpen, onStateChange, cartItemCount, children} = this.props;

    return (
      <CSSTransitionGroup
        transitionName="side-menu"
        transitionEnterTimeout={300}
        transitionLeaveTimeout={300}
      >
        {isOpen && (
          <div key="side-menu" className={styles.sideMenu}>
            <Helmet>
              <body className="prevent-scroll"/>
            </Helmet>

            <div className={styles.sideMenu_wrapper}>
              <div className={styles.sideMenu_top}>
                <header className={styles.sideMenu_header}>
                  <RoundButton
                    onClick={() => onStateChange(false)}
                    accent
                  >
                    <CloseIcon/>
                  </RoundButton>

                  <div className={styles.sideMenu_logo}>
                    <Logo/>
                  </div>

                  <RoundButton>
                    <CartIcon/>
                    {!!cartItemCount && (
                      <span className={cartCounter.cartCounter}>{cartItemCount}</span>
                    )}
                  </RoundButton>
                </header>

                <div className={styles.sideMenu_topBottom}>
                  {/* TODO: Implement when auth will be available */}
                  {/*<button className={signIn.signIn}>*/}
                  {/*  <span className={signIn.signInIcon}/>*/}
                  {/*  <span className={signIn.signInText}>Sign in</span>*/}
                  {/*</button>*/}

                  <div className={styles.sideMenu_social}>
                    <RoundSocials/>
                  </div>
                </div>
              </div>

              <div className={styles.sideMenu_content}>
                {children}
              </div>

              <div className={styles.sideMenu_bottom}>
                <div className={styles.sideMenu_controls}>
                  <ChannelDropdown mobile/>

                  <div className={styles.sideMenu_search}>
                    <SearchBarContainer/>
                  </div>
                </div>

                <div className={styles.sideMenu_additionalLinks}>
                  {SideMenu.menu.map(({name, to}, idx) => (
                    <Link
                      key={idx}
                      className={styles.sideMenu_additionalLink}
                      to={to}
                    >
                      {name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </CSSTransitionGroup>
    );
  }
}

SideMenu.propTypes = {
  isOpen: PropTypes.bool,
  onStateChange: PropTypes.func,
  children: PropTypes.node,
  dark: PropTypes.bool
};



// WEBPACK FOOTER //
// ./components/sideMenu/SideMenu.js